export default "__VITE_ASSET__TSGRytMi__"